<template>
    <div class="reset-password-form">
        <v-form
            @submit.prevent
            v-model="valid"
        >
            <v-container class="ma-0 pa-0">
                <v-row>
                    <v-col
                        cols="12"
                        class="mt-12"
                    >
                        <h2 class="reset-password-title">Изменить пароль</h2>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-10 login-form-text-field"
                                color="#0075AA"
                                label="Введите новый пароль"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="password"
                                :rules="[password_rules]"
                                type="password"
                            >
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div
                            class="ml-12 mr-12 mt-n2 d-flex justify-start login-form-error-msg"
                        >
                            {{ msg }}
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div
                            class="ml-12 mr-12 mt-10 mb-12 d-flex justify-space-between"
                        >
                            <div>
                                <v-btn
                                    type="submit"
                                    variant="flat"
                                    color="#0075AA"
                                    height="48"
                                    @click="resetPassword"
                                >
                                    Изменить пароль
                                </v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>
<script>
import { useAuthStore } from '@/store/auth'

export default {
    name: 'ResetPasswordForm',
    props: {
        token: String
    },
    data() {
        return {
            password: '',
            msg: '',
            valid: false,
            password_rules: (value) => {
                if (!value) return 'Необходимо ввести пароль'
                if (value.length > 20)
                    return 'Пароль не должен быть длиннее 20 символов'
                if (value.length < 6)
                    return 'Пароль не должен быть короче 6 символов'
                if (value.indexOf(' ') > 0)
                    return 'Пароль не должен содержать пробелы'
                return true
            }
        }
    },
    methods: {
        async resetPassword() {
            if (!this.valid) {
                return
            }

            const authStore = useAuthStore()
            await authStore
                .resetPassword(this.$props.token, this.password)
                .then(() => {
                    alert(
                        'Пароль успешно сброшен. Нажмите на кнопку, для возвращения на главную страницу'
                    )
                    this.$router.replace('/')
                })
                .catch(() => {
                    alert(
                        'Что-то пошло не так. Проверьте данные и попробуйте еще раз'
                    )
                })
        }
    }
}
</script>
